import config from "./../config";

export default {
    buildImaginImageUrl(maker, model, bodyDesign) {
        console.log(bodyDesign);
        let url = 'https://cdn.imagin.studio/getimage?customer=cdsysteme&channelName=webpage&width=400&filetype=jpg&zoomLevel=30&angle=22';


        if(maker) {
            url += "&make="+maker.label;        
        }

        if(model) {
            url +=  "&modelFamily="+model.label;
        }

        if(bodyDesign) {
            url +=  "&modelVariant="+bodyDesign.label;
        }

        return url;
    },
    buildImageUrl(obj) {
        let dbName = "SSCD" in obj.photo_path ? "SSCD" : "NSCD";

        return (
            config.apiUri +
            "/ngphotos/" +
            dbName +
            "/" +
            obj.photo_path[dbName] +
            "/" +
            obj.photo_filename[dbName] +
            ".JPG"
        );
    },
    buildImaginImageUrlForPerspective(engine, perspective, color, maker, model, bodyDesign) {
        let url = this.buildImaginImageUrl(maker, model, bodyDesign);

        if(color) {
            console.log("Selected color: "+color.label);
            url += "&paintdescription="+color.label.toLowerCase();
        }

        return url;
    },
    buildImageUrlForPerspective(obj, perspective, color, maker, model) {
        if(!obj) {
            return null;
        }
        let dbName = "SSCD" in obj.photo_path ? "SSCD" : "NSCD";


        let segments = obj.photo_path[dbName].split('/');
  
        segments[0] = maker.label.toUpperCase();
        segments[1] = model.label.toUpperCase();
  
        let finalPath = segments.join('/');

        let imagePath = config.apiUri +
        "/ngphotos/" +
        dbName +
        "/" +
        finalPath +
        "/" +
        obj.photo_filename[dbName];

        if(color) {
            imagePath+="_"+perspective;
            imagePath = imagePath + '_' + color.option_code;
        }

        imagePath = imagePath + ".JPG";

        return imagePath;
    }
}